export const regionOptions = [
  { label: "Arica y Parinacota", value: "arica_y_parinacota" },
  { label: "Tarapacá", value: "tarapaca" },
  { label: "Antofagasta", value: "antofagasta" },
  { label: "Atacama", value: "atacama" },
  { label: "Coquimbo", value: "coquimbo" },
  { label: "Valparaíso", value: "valparaiso" },
  {
    label: "Metropolitana de Santiago",
    value: "metropolitana_de_santiago",
  },
  {
    label: "Libertador General Bernardo O'Higgins",
    value: "libertador_general_bernardo_ohiggins",
  },
  { label: "Maule", value: "maule" },
  { label: "Ñuble", value: "nuble" },
  { label: "Biobío", value: "biobio" },
  { label: "La Araucanía", value: "la_araucania" },
  { label: "Los Ríos", value: "los_rios" },
  { label: "Los Lagos", value: "los_lagos" },
  {
    label: "Aysén del General Carlos Ibáñez del Campo",
    value: "aysen_del_general_carlos_ibanez_del_campo",
  },
  {
    label: "Magallanes y de la Antártica Chilena",
    value: "magallanes_y_antartica_chilena",
  },
];

export const occupationOptions = [
  {
    label: "Estudiante de Educación Superior (Técnico / Pregrado)",
    value: "higher_education_student",
  },
  {
    label: "Estudiante de Postgrado (Magíster / Doctorado)",
    value: "postgraduate_student",
  },
  {
    label: "Emprendedor(a) a tiempo completo",
    value: "full_time_entrepreneur",
  },
  {
    label: "Profesional / Trabajador(a) dependiente",
    value: "employed_professional",
  },
  {
    label: "Trabajador(a) independiente / Freelancer",
    value: "independent_worker",
  },
  { label: "Otro", value: "other" },
];

export const obstacleOptions = [
  {
    label: "Falta de claridad en el modelo de negocio",
    value: "business_model_clarity",
  },
  {
    label: "Dificultad para formular la propuesta técnica/financiera",
    value: "technical_financial_proposal",
  },
  {
    label: "Falta de tiempo / Desorden en la información",
    value: "time_or_information_organization",
  },
  {
    label: "Búsqueda de financiamiento / Fondos públicos (Corfo, Sercotec, etc.)",
    value: "funding_search",
  },
];

export const aiExperienceOptions = [
  { label: "Sí, frecuentemente", value: "frequently" },
  {
    label: "Solo de forma ocasional (ej: ChatGPT para textos)",
    value: "occasionally",
  },
  { label: "No, es mi primera vez", value: "first_time" },
];

export const expectationOptions = [
  {
    label: "Estructurar y ordenar mi modelo de negocio.",
    value: "structure_business_model",
  },
  {
    label: "Probar herramientas con Inteligencia Artificial aplicadas a mi startup.",
    value: "try_ai_tools",
  },
  {
    label: "Preparar mi proyecto para postular a fondos públicos o inversión privada.",
    value: "prepare_for_funding",
  },
  {
    label: "Participar por el gran premio del sorteo.",
    value: "participate_in_prize_draw",
  },
];

export const getOptionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label || "";
